import { createUseStyles } from "react-jss";

export const ConfigDockBlockFilterStyle = createUseStyles((theme: any) => ({
    filter: {
        display: "flex",
        alignItems: "center",
        gap: theme.gaps.filter.default,
    },
    longItem: {
        width: 450,
    },
    item: {
        width: 200,
    },
}));
